import type { EntryType, TimeEntry, WorkSummary } from '../types/domain';

export const sequence: EntryType[] = ['clock_in', 'break_start', 'break_end', 'clock_out'];
export const entryLabel: Record<EntryType, string> = { clock_in: 'Registrar entrada', break_start: 'Iniciar intervalo', break_end: 'Registrar retorno', clock_out: 'Registrar saída' };

export function calculateWorkDay(entries: Pick<TimeEntry, 'type' | 'recordedAt'>[], expectedMinutes = 480): WorkSummary {
  const sorted = [...entries].sort((a, b) => Date.parse(a.recordedAt) - Date.parse(b.recordedAt));
  const riskFlags: string[] = [];
  for (let index = 0; index < sorted.length; index += 1) if (sorted[index].type !== sequence[index]) riskFlags.push('INVALID_SEQUENCE');
  const nextExpectedAction = sorted.length < sequence.length ? sequence[sorted.length] : null;
  const moments = Object.fromEntries(sorted.map((entry) => [entry.type, Date.parse(entry.recordedAt)]));
  const now = Date.now();
  const start = moments.clock_in;
  const finish = moments.clock_out ?? now;
  const breakStart = moments.break_start;
  const breakFinish = moments.break_end ?? (breakStart ? now : undefined);
  const breakMinutes = breakStart && breakFinish ? Math.max(0, Math.round((breakFinish - breakStart) / 60000)) : 0;
  const workedMinutes = start ? Math.max(0, Math.round((finish - start) / 60000) - breakMinutes) : 0;
  return { nextExpectedAction, workedMinutes, breakMinutes, overtimeMinutes: Math.max(0, workedMinutes - expectedMinutes), missingMinutes: Math.max(0, expectedMinutes - workedMinutes), riskFlags };
}

export function isValidNextEntry(entries: Pick<TimeEntry, 'type'>[], action: EntryType) { return entries.length < sequence.length && sequence[entries.length] === action; }
export function formatMinutes(minutes: number) { const signal = minutes < 0 ? '-' : ''; const absolute = Math.abs(minutes); return `${signal}${Math.floor(absolute / 60)}h ${String(absolute % 60).padStart(2, '0')}min`; }
